// src/components/forms/register/BasicInfoSection.jsx
import React, { useState } from 'react';
import { User, Mail, Lock, Eye, EyeOff, Hash } from 'lucide-react';
import { InputField } from '../shared/InputField';

export const BasicInfoSection = ({ formData, setFormData, showPassword, setShowPassword }) => {
  const [errors, setErrors] = useState({
    username: '',
    idNumber: '',
    email: '',
    password: ''
  });

  // Determine label and key based on role
  let idLabel = "ID Number";
  let idValue = formData.idNumber; // Default for other roles (if any)
  let updateIdField = (value) => setFormData({ ...formData, idNumber: value });
  let idField = "idNumber";

  if (formData.role === "student") {
    idLabel = "Student ID";
    idValue = formData.studentInfo?.studentId || "";
    idField = "studentId";
    updateIdField = (value) =>
      setFormData({
        ...formData,
        studentInfo: {
          ...formData.studentInfo,
          studentId: value,
        },
      });
  } else if (formData.role === "staff") {
    idLabel = "Employee No.";
    idValue = formData.staffInfo?.staffId || "";
    idField = "staffId";
    updateIdField = (value) =>
      setFormData({
        ...formData,
        staffInfo: {
          ...formData.staffInfo,
          staffId: value,
        },
      });
  }

  // Validation functions
  const validateUsername = (value) => {
    if (!value) {
      setErrors(prev => ({ ...prev, username: 'Username is required' }));
      return false;
    } else if (!/^[a-z][a-z]+$/i.test(value)) {
      setErrors(prev => ({ ...prev, username: 'Username must be in format: first initial + last name (e.g., amwangi)' }));
      return false;
    } else {
      setErrors(prev => ({ ...prev, username: '' }));
      return true;
    }
  };

  const validateId = (value) => {
    if (!value) {
      setErrors(prev => ({ ...prev, idNumber: `${idLabel} is required` }));
      return false;
    } else {
      setErrors(prev => ({ ...prev, idNumber: '' }));
      return true;
    }
  };

  const validateEmail = (value) => {
    if (!value) {
      setErrors(prev => ({ ...prev, email: 'Email is required' }));
      return false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrors(prev => ({ ...prev, email: 'Please enter a valid email address' }));
      return false;
    } else {
      setErrors(prev => ({ ...prev, email: '' }));
      return true;
    }
  };

  const validatePassword = (value) => {
    if (!value) {
      setErrors(prev => ({ ...prev, password: 'Password is required' }));
      return false;
    } else if (value.length < 6) {
      setErrors(prev => ({ ...prev, password: 'Password must be at least 6 characters long' }));
      return false;
    } else {
      setErrors(prev => ({ ...prev, password: '' }));
      return true;
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm space-y-4">
      <h3 className="text-lg font-medium text-gray-900 border-b pb-2">Basic Information</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InputField
          id="username"
          label="Username (initial + lastname)"
          required
          icon={<User className="h-5 w-5 text-gray-400" />}
          value={formData.username}
          onChange={(e) => {
            setFormData({ ...formData, username: e.target.value.toLowerCase() });
            if (errors.username) validateUsername(e.target.value);
          }}
          validate={validateUsername}
          error={errors.username}
          placeholder="jdoe"
        />

        <InputField
          id="idField"
          label={idLabel}
          required
          icon={<Hash className="h-5 w-5 text-gray-400" />}
          value={idValue}
          onChange={(e) => {
            updateIdField(e.target.value);
            if (errors.idNumber) validateId(e.target.value);
          }}
          validate={validateId}
          error={errors.idNumber}
          placeholder={formData.role === "student" ? "STUD001234" : "EMP001234"}
        />
      </div>

      <InputField
        id="email"
        label="Email address"
        type="email"
        required
        icon={<Mail className="h-5 w-5 text-gray-400" />}
        value={formData.email}
        onChange={(e) => {
          setFormData({ ...formData, email: e.target.value });
          if (errors.email) validateEmail(e.target.value);
        }}
        validate={validateEmail}
        error={errors.email}
        placeholder="john.doe@uzima.ac.ke"
      />

      <InputField
        id="password"
        label="Password (6 characters with at least one number)"
        type={showPassword ? "text" : "password"}
        required
        icon={<Lock className="h-5 w-5 text-gray-400" />}
        value={formData.password}
        onChange={(e) => {
          setFormData({ ...formData, password: e.target.value });
          if (errors.password) validatePassword(e.target.value);
        }}
        validate={validatePassword}
        error={errors.password}
        minLength={6}
        placeholder="Enter secure password"
        endAdornment={
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
          </button>
        }
      />
    </div>
  );
};

export default BasicInfoSection;

// export const BasicInfoSection = ({ formData, setFormData, showPassword, setShowPassword }) => {
//   // Determine label and key based on role
//   let idLabel = "ID Number";
//   let idValue = formData.idNumber; // Default for other roles (if any)
//   let updateIdField = (value) => setFormData({ ...formData, idNumber: value });

//   if (formData.role === "student") {
//     idLabel = "Student ID";
//     idValue = formData.studentInfo?.studentId || "";
//     updateIdField = (value) =>
//       setFormData({
//         ...formData,
//         studentInfo: {
//           ...formData.studentInfo,
//           studentId: value,
//         },
//       });
//   } else if (formData.role === "staff") {
//     idLabel = "Employee No.";
//     idValue = formData.staffInfo?.staffId || "";
//     updateIdField = (value) =>
//       setFormData({
//         ...formData,
//         staffInfo: {
//           ...formData.staffInfo,
//           staffId: value,
//         },
//       });
//   }

//   return (
//     <div className="bg-white p-6 rounded-lg shadow-sm space-y-4">
//       <h3 className="text-lg font-medium text-gray-900 border-b pb-2">Basic Information</h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <InputField
//           id="username"
//           label="Username (firstname_lastname)"
//           required
//           icon={<User className="h-5 w-5 text-gray-400" />}
//           value={formData.username}
//           onChange={(e) => setFormData({ ...formData, username: e.target.value })}
//         />

//         <InputField
//           id="idField"
//           label={idLabel}
//           icon={<Hash className="h-5 w-5 text-gray-400" />}
//           value={idValue}
//           onChange={(e) => updateIdField(e.target.value)}
//         />
//       </div>

//       <InputField
//         id="email"
//         label="Email address"
//         type="email"
//         required
//         icon={<Mail className="h-5 w-5 text-gray-400" />}
//         value={formData.email}
//         onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//       />

//       <InputField
//         id="password"
//         label="Password"
//         type={showPassword ? "text" : "password"}
//         required
//         icon={<Lock className="h-5 w-5 text-gray-400" />}
//         value={formData.password}
//         onChange={(e) => setFormData({ ...formData, password: e.target.value })}
//         minLength={6}
//         endAdornment={
//           <button
//             type="button"
//             className="absolute inset-y-0 right-0 pr-3 flex items-center"
//             onClick={() => setShowPassword(!showPassword)}
//           >
//             {showPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
//           </button>
//         }
//       />
//     </div>
//   );
// };

// export default BasicInfoSection;
